import logger from 'utils/logger.util';

import { SALONSBYUSER_FAILURE, SALONSBYUSER_REQUEST, SALONSBYUSER_SUCCESS } from 'salon/constants';

const L = logger('salonListReducer');

const defaultState = () => ({
  isFetching: false,
  errorMessage: null,
  authenticated: true,
  response: { manager: [], receptionist: [], support: [] },
  ok: null,
});

const salonListReducer = (state = defaultState(), action) => {
  const { errorMessage, response, type } = action ?? {};

  if (!type) return state;
  if (errorMessage) L.warn('()', 'errorMessage:', errorMessage);

  if (SALONSBYUSER_REQUEST === type) return { ...state, isFetching: true, errorMessage: null, ok: null };
  if (SALONSBYUSER_SUCCESS === type) return { ...state, isFetching: false, errorMessage: null, response, ok: true };
  if (SALONSBYUSER_FAILURE === type) return { ...state, isFetching: false, errorMessage, ok: false };

  return state;
};

// noinspection JSUnusedGlobalSymbols
export default salonListReducer;
